import { Inject, Injectable, Optional, inject } from "@angular/core";
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { firstValueFrom, map } from "rxjs";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { Meta, Title } from "@angular/platform-browser";
import { SeoService } from "src/app/services/seo.service";

@Injectable({ providedIn: "root" })
export class AIIllustrationCollectionResolver implements Resolve<any> {
  afs = inject(AngularFirestore);
  constructor(
    private meta: Meta, // private socialService: SocialService,
    private title: Title,
    public router: Router,
    private seo: SeoService
  ) {}
  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<any> {
    const slug = route.paramMap.get("slug");
    //console.log("Slug:", slug);
    const ref = this.afs.collection("collectionMaster", (ref) =>
      ref.where("slug", "==", slug).orderBy("createdOn", "desc")
    );
    const data$ = ref.valueChanges().pipe(
      map((res) => {
        this.populateMetaTags(res[0], route);
        return res[0];
      })
    ); // Get single item

    return await firstValueFrom(data$);
  }

  populateMetaTags(data, route) {
    //console.log(route.paramMap, data);
    const title = data.collectionName;
    const desc =
      data.desc ||
      "Illusbook offers a collection of stunning illustrations. Browse and download the perfect illustrations for your projects today.";
    const image = data.thumbUrl;
    const keywords = data.metadata
      ? data.metadata.join(", ")
      : "illusbook, illusbook.com, free illustrations, high-quality illustrations, professional illustrations, SaaS illustrations, fintech illustrations, HR tech illustrations, healthcare illustrations, marketing illustrations, education illustrations, tech product illustrations, app illustrations, website illustrations, UI illustrations, UX illustrations, dashboard illustrations, landing page illustrations, vector illustrations, illustration library, business illustrations, startup illustrations, creative assets for designers, ready-to-use illustrations, digital product illustrations, custom illustrations for SaaS, design resources for tech companies, modern flat illustrations, premium free illustrations, product UI visuals";
    //console.log(
    //   "Router URL:",
    //   "https://illusbook.com/illustration-collection/" + data.slug
    // );
    //console.log("Router URL:", this.router);
    // const protocol =
    //   this.request.headers["x-forwarded-proto"] || this.request.protocol;
    // const host = this.request.headers.host;
    // const originalUrl = this.request.originalUrl;
    // const fullURL = `${protocol}://${host}${originalUrl}`;
    const fullURL = `https://illusbook.com/illustration-collection/${data.slug}`;
    //console.log("Window URL:", fullURL);
    this.title.setTitle(`${title} | Illusbook`);
    this.setMetaTag("name", "title", title);
    this.setMetaTag("name", "keywords", keywords);
    this.setMetaTag("name", "description", desc);
    this.setMetaTag("name", "og:title", title);
    this.setMetaTag("name", "keywords", keywords);
    this.setMetaTag("property", "og:title", title);
    this.setMetaTag("property", "og:description", desc);
    this.setMetaTag("property", "og:image", image);
    this.setMetaTag("property", "og:url", fullURL);
    this.setMetaTag("property", "og:type", "article");
    this.setMetaTag("property", "og:site_name", "Illusbook");
    this.setMetaTag("property", "twitter:card", "summary_large_image");

    const previewUrl = data?.previewUrl || data?.jpeg || data?.png;

    this.seo.setJSONLD({
      "@context": "https://schema.org",
      "@type": "ImageObject",
      name: title,
      description: desc,
      url: fullURL,
      image: previewUrl,
      contentUrl: image,
      author: {
        "@type": "Organization",
        name: "Illusbook",
      },
      license: "https://illusbook.com/license",
    });
  }

  setMetaTag(
    attrName: "name" | "property",
    attrValue: string,
    content: string
  ) {
    const selector = `${attrName}="${attrValue}"`;
    //console.log(selector);
    this.meta.removeTag(selector);
    this.meta.addTag({ [attrName]: attrValue, content });
    // this.meta.updateTag({ [attrName]: attrValue, content });
  }
}
